
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1126"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1126"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6TaBW", function(module, exports) {

$parcel$export(module.exports, "countryCodes", () => $50401c43f41e65e3$export$7bc41e2d36612b98);
const $50401c43f41e65e3$export$7bc41e2d36612b98 = [
    {
        name: "Afghanistan",
        code: "+93"
    },
    {
        name: "Albania",
        code: "+355"
    },
    {
        name: "Algeria",
        code: "+213"
    },
    {
        name: "Andorra",
        code: "+376"
    },
    {
        name: "Angola",
        code: "+244"
    },
    {
        name: "Argentina",
        code: "+54"
    },
    {
        name: "Armenia",
        code: "+374"
    },
    {
        name: "Australia",
        code: "+61"
    },
    {
        name: "Austria",
        code: "+43"
    },
    {
        name: "Azerbaijan",
        code: "+994"
    },
    {
        name: "Bahamas",
        code: "+1-242"
    },
    {
        name: "Bahrain",
        code: "+973"
    },
    {
        name: "Bangladesh",
        code: "+880"
    },
    {
        name: "Barbados",
        code: "+1-246"
    },
    {
        name: "Belarus",
        code: "+375"
    },
    {
        name: "Belgium",
        code: "+32"
    },
    {
        name: "Belize",
        code: "+501"
    },
    {
        name: "Benin",
        code: "+229"
    },
    {
        name: "Bhutan",
        code: "+975"
    },
    {
        name: "Bolivia",
        code: "+591"
    },
    {
        name: "Bosnia and Herzegovina",
        code: "+387"
    },
    {
        name: "Botswana",
        code: "+267"
    },
    {
        name: "Brazil",
        code: "+55"
    },
    {
        name: "Brunei",
        code: "+673"
    },
    {
        name: "Bulgaria",
        code: "+359"
    },
    {
        name: "Burkina Faso",
        code: "+226"
    },
    {
        name: "Burundi",
        code: "+257"
    },
    {
        name: "Cambodia",
        code: "+855"
    },
    {
        name: "Cameroon",
        code: "+237"
    },
    {
        name: "Canada",
        code: "+1"
    },
    {
        name: "Cape Verde",
        code: "+238"
    },
    {
        name: "Central African Republic",
        code: "+236"
    },
    {
        name: "Chad",
        code: "+235"
    },
    {
        name: "Chile",
        code: "+56"
    },
    {
        name: "China",
        code: "+86"
    },
    {
        name: "Colombia",
        code: "+57"
    },
    {
        name: "Comoros",
        code: "+269"
    },
    {
        name: "Congo (Congo-Brazzaville)",
        code: "+242"
    },
    {
        name: "Costa Rica",
        code: "+506"
    },
    {
        name: "Croatia",
        code: "+385"
    },
    {
        name: "Cuba",
        code: "+53"
    },
    {
        name: "Cyprus",
        code: "+357"
    },
    {
        name: "Czech Republic",
        code: "+420"
    },
    {
        name: "Denmark",
        code: "+45"
    },
    {
        name: "Djibouti",
        code: "+253"
    },
    {
        name: "Dominica",
        code: "+1-767"
    },
    {
        name: "Dominican Republic",
        code: "+1-809"
    },
    {
        name: "Ecuador",
        code: "+593"
    },
    {
        name: "Egypt",
        code: "+20"
    },
    {
        name: "El Salvador",
        code: "+503"
    },
    {
        name: "Equatorial Guinea",
        code: "+240"
    },
    {
        name: "Eritrea",
        code: "+291"
    },
    {
        name: "Estonia",
        code: "+372"
    },
    {
        name: "Eswatini",
        code: "+268"
    },
    {
        name: "Ethiopia",
        code: "+251"
    },
    {
        name: "Fiji",
        code: "+679"
    },
    {
        name: "Finland",
        code: "+358"
    },
    {
        name: "France",
        code: "+33"
    },
    {
        name: "Gabon",
        code: "+241"
    },
    {
        name: "Gambia",
        code: "+220"
    },
    {
        name: "Georgia",
        code: "+995"
    },
    {
        name: "Germany",
        code: "+49"
    },
    {
        name: "Ghana",
        code: "+233"
    },
    {
        name: "Greece",
        code: "+30"
    },
    {
        name: "Grenada",
        code: "+1-473"
    },
    {
        name: "Guatemala",
        code: "+502"
    },
    {
        name: "Guinea",
        code: "+224"
    },
    {
        name: "Guinea-Bissau",
        code: "+245"
    },
    {
        name: "Guyana",
        code: "+592"
    },
    {
        name: "Haiti",
        code: "+509"
    },
    {
        name: "Honduras",
        code: "+504"
    },
    {
        name: "Hungary",
        code: "+36"
    },
    {
        name: "Iceland",
        code: "+354"
    },
    {
        name: "India",
        code: "+91"
    },
    {
        name: "Indonesia",
        code: "+62"
    },
    {
        name: "Iran",
        code: "+98"
    },
    {
        name: "Iraq",
        code: "+964"
    },
    {
        name: "Ireland",
        code: "+353"
    },
    {
        name: "Israel",
        code: "+972"
    },
    {
        name: "Italy",
        code: "+39"
    },
    {
        name: "Jamaica",
        code: "+1-876"
    },
    {
        name: "Japan",
        code: "+81"
    },
    {
        name: "Jordan",
        code: "+962"
    },
    {
        name: "Kazakhstan",
        code: "+7"
    },
    {
        name: "Kenya",
        code: "+254"
    },
    {
        name: "Kiribati",
        code: "+686"
    },
    {
        name: "Kuwait",
        code: "+965"
    },
    {
        name: "Kyrgyzstan",
        code: "+996"
    },
    {
        name: "Laos",
        code: "+856"
    },
    {
        name: "Latvia",
        code: "+371"
    },
    {
        name: "Lebanon",
        code: "+961"
    },
    {
        name: "Lesotho",
        code: "+266"
    },
    {
        name: "Liberia",
        code: "+231"
    },
    {
        name: "Libya",
        code: "+218"
    },
    {
        name: "Liechtenstein",
        code: "+423"
    },
    {
        name: "Lithuania",
        code: "+370"
    },
    {
        name: "Luxembourg",
        code: "+352"
    },
    {
        name: "Madagascar",
        code: "+261"
    },
    {
        name: "Malawi",
        code: "+265"
    },
    {
        name: "Malaysia",
        code: "+60"
    },
    {
        name: "Maldives",
        code: "+960"
    },
    {
        name: "Mali",
        code: "+223"
    },
    {
        name: "Malta",
        code: "+356"
    },
    {
        name: "Mauritania",
        code: "+222"
    },
    {
        name: "Mauritius",
        code: "+230"
    },
    {
        name: "Mexico",
        code: "+52"
    },
    {
        name: "Moldova",
        code: "+373"
    },
    {
        name: "Monaco",
        code: "+377"
    },
    {
        name: "Mongolia",
        code: "+976"
    },
    {
        name: "Montenegro",
        code: "+382"
    },
    {
        name: "Morocco",
        code: "+212"
    },
    {
        name: "Mozambique",
        code: "+258"
    },
    {
        name: "Myanmar",
        code: "+95"
    },
    {
        name: "Namibia",
        code: "+264"
    },
    {
        name: "Nepal",
        code: "+977"
    },
    {
        name: "Netherlands",
        code: "+31"
    },
    {
        name: "New Zealand",
        code: "+64"
    },
    {
        name: "Nicaragua",
        code: "+505"
    },
    {
        name: "Niger",
        code: "+227"
    },
    {
        name: "Nigeria",
        code: "+234"
    },
    {
        name: "North Korea",
        code: "+850"
    },
    {
        name: "North Macedonia",
        code: "+389"
    },
    {
        name: "Norway",
        code: "+47"
    },
    {
        name: "Oman",
        code: "+968"
    },
    {
        name: "Pakistan",
        code: "+92"
    },
    {
        name: "Palau",
        code: "+680"
    },
    {
        name: "Panama",
        code: "+507"
    },
    {
        name: "Papua New Guinea",
        code: "+675"
    },
    {
        name: "Paraguay",
        code: "+595"
    },
    {
        name: "Peru",
        code: "+51"
    },
    {
        name: "Philippines",
        code: "+63"
    },
    {
        name: "Poland",
        code: "+48"
    },
    {
        name: "Portugal",
        code: "+351"
    },
    {
        name: "Qatar",
        code: "+974"
    },
    {
        name: "Romania",
        code: "+40"
    },
    {
        name: "Russia",
        code: "+7"
    },
    {
        name: "Rwanda",
        code: "+250"
    },
    {
        name: "Saint Kitts and Nevis",
        code: "+1-869"
    },
    {
        name: "Saint Lucia",
        code: "+1-758"
    },
    {
        name: "Saint Vincent and the Grenadines",
        code: "+1-784"
    },
    {
        name: "Samoa",
        code: "+685"
    },
    {
        name: "San Marino",
        code: "+378"
    },
    {
        name: "Saudi Arabia",
        code: "+966"
    },
    {
        name: "Senegal",
        code: "+221"
    },
    {
        name: "Serbia",
        code: "+381"
    },
    {
        name: "Seychelles",
        code: "+248"
    },
    {
        name: "Sierra Leone",
        code: "+232"
    },
    {
        name: "Singapore",
        code: "+65"
    },
    {
        name: "Slovakia",
        code: "+421"
    },
    {
        name: "Slovenia",
        code: "+386"
    },
    {
        name: "Solomon Islands",
        code: "+677"
    },
    {
        name: "Somalia",
        code: "+252"
    },
    {
        name: "South Africa",
        code: "+27"
    },
    {
        name: "South Korea",
        code: "+82"
    },
    {
        name: "South Sudan",
        code: "+211"
    },
    {
        name: "Spain",
        code: "+34"
    },
    {
        name: "Sri Lanka",
        code: "+94"
    },
    {
        name: "Sudan",
        code: "+249"
    },
    {
        name: "Suriname",
        code: "+597"
    },
    {
        name: "Sweden",
        code: "+46"
    },
    {
        name: "Switzerland",
        code: "+41"
    },
    {
        name: "Syria",
        code: "+963"
    },
    {
        name: "Taiwan",
        code: "+886"
    },
    {
        name: "Tajikistan",
        code: "+992"
    },
    {
        name: "Tanzania",
        code: "+255"
    },
    {
        name: "Thailand",
        code: "+66"
    },
    {
        name: "Togo",
        code: "+228"
    },
    {
        name: "Tonga",
        code: "+676"
    },
    {
        name: "Trinidad and Tobago",
        code: "+1-868"
    },
    {
        name: "Tunisia",
        code: "+216"
    },
    {
        name: "Turkey",
        code: "+90"
    },
    {
        name: "Turkmenistan",
        code: "+993"
    },
    {
        name: "Uganda",
        code: "+256"
    },
    {
        name: "Ukraine",
        code: "+380"
    },
    {
        name: "United Arab Emirates",
        code: "+971"
    },
    {
        name: "United Kingdom",
        code: "+44"
    },
    {
        name: "United States",
        code: "+1"
    },
    {
        name: "Uruguay",
        code: "+598"
    },
    {
        name: "Uzbekistan",
        code: "+998"
    },
    {
        name: "Vanuatu",
        code: "+678"
    },
    {
        name: "Vatican City",
        code: "+379"
    },
    {
        name: "Venezuela",
        code: "+58"
    },
    {
        name: "Vietnam",
        code: "+84"
    },
    {
        name: "Yemen",
        code: "+967"
    },
    {
        name: "Zambia",
        code: "+260"
    },
    {
        name: "Zimbabwe",
        code: "+263"
    }
];

});


var $6TaBW = parcelRequire("6TaBW");

var $cP3LP = parcelRequire("cP3LP");
const $0a79f28eb2b649f5$var$DELETION_STEPS = {
    FORM: "form",
    OTP: "otp"
};
const $0a79f28eb2b649f5$var$state = {
    step: $0a79f28eb2b649f5$var$DELETION_STEPS.FORM,
    deletionSessionToken: "",
    sessionExpiresAt: 0
};
document.addEventListener("DOMContentLoaded", ()=>{
    // ================================================
    // CONFIRM PHRASE + DELETE BUTTON ENABLE LOGIC
    // ================================================
    const confirmPhraseInput = document.getElementById("action-confirmation");
    const deleteButton = document.getElementById("delete-button");
    const requiredPhrase = "delete my account"; // The exact phrase to match
    const updateDeleteButtonEnabled = ()=>{
        if (!confirmPhraseInput || !deleteButton) return;
        const phraseOk = confirmPhraseInput.value === requiredPhrase;
        deleteButton.disabled = !phraseOk;
    };
    if (confirmPhraseInput) confirmPhraseInput.addEventListener("input", updateDeleteButtonEnabled);
    updateDeleteButtonEnabled();
    // ================================================
    // CUSTOM DROPDOWN LOGIC (Identifier Type)
    // ================================================
    const identifierTypeDropdownElement = document.getElementById("identifier-type-dropdown");
    const identifierTypeInput = document.getElementById("identifier-type");
    const identifierInput = document.getElementById("identifier");
    const phoneInputContainer = document.getElementById("phone-input-container");
    const selectedIdentifierType = document.getElementById("selected-identifier-type");
    const phoneInput = document.getElementById("phone");
    const countryCodeDropdownElement = document.getElementById("country-code-dropdown");
    const countryCodeInput = document.getElementById("country-code");
    const selectedCountryCode = document.getElementById("selected-country-code");
    const countryCodeDropdownOptions = countryCodeDropdownElement ? countryCodeDropdownElement.querySelector(".dropdown-options") : null;
    if (countryCodeDropdownOptions && typeof (0, $6TaBW.countryCodes) !== "undefined") {
        (0, $6TaBW.countryCodes).forEach((country)=>{
            const a = document.createElement("a");
            a.href = "#";
            a.setAttribute("data-value", country.code);
            a.textContent = `${country.code} (${country.name})`;
            countryCodeDropdownOptions.appendChild(a);
        });
        const defaultCountry = (0, $6TaBW.countryCodes).find((country)=>country.code === "+91");
        if (defaultCountry) {
            selectedCountryCode.textContent = `${defaultCountry.code} (${defaultCountry.name})`;
            countryCodeInput.value = defaultCountry.code;
        }
    }
    const updateIdentifierInputVisibility = (selectedType)=>{
        if (selectedType === "phone") {
            identifierInput.style.display = "none";
            phoneInputContainer.style.display = "flex";
            identifierInput.required = false;
            phoneInput.required = true;
            identifierInput.value = "";
        } else {
            identifierInput.style.display = "block";
            phoneInputContainer.style.display = "none";
            identifierInput.required = true;
            phoneInput.required = false;
            identifierInput.placeholder = `Enter your ${selectedType}`;
            phoneInput.value = "";
        }
    };
    if (identifierTypeDropdownElement) identifierTypeDropdownElement.addEventListener("dropdown-change", (e)=>{
        const selectedValue = e.detail.value;
        identifierTypeInput.value = selectedValue;
        selectedIdentifierType.textContent = e.detail.text;
        updateIdentifierInputVisibility(selectedValue);
    });
    updateIdentifierInputVisibility(identifierTypeInput.value);
    if (countryCodeDropdownElement) countryCodeDropdownElement.addEventListener("dropdown-change", (e)=>{
        countryCodeInput.value = e.detail.value;
        selectedCountryCode.textContent = e.detail.text;
    });
    // ================================================
    // STEP NAVIGATION UI (NEW: Step 1 → Step 2)
    // ================================================
    $0a79f28eb2b649f5$var$injectOtpStepUi();
    document.getElementById("delete-user-form").addEventListener("submit", async function(event) {
        event.preventDefault();
        const formEl = event.currentTarget;
        const identifierType = document.getElementById("identifier-type").value;
        const identifier = document.getElementById("identifier").value.trim();
        const phone = document.getElementById("phone").value.trim();
        const countryCode = document.getElementById("country-code").value;
        const password = document.getElementById("password").value;
        const reason = document.getElementById("reason").value.trim();
        if (!password) {
            (0, $cP3LP.showToast)("Please enter your password.", "error");
            return;
        }
        let finalIdentifier;
        if (identifierType === "phone") {
            if (!phone) {
                (0, $cP3LP.showToast)("Please enter your phone number.", "error");
                return;
            }
            finalIdentifier = `${countryCode}${phone}`;
        } else {
            if (!identifier) {
                (0, $cP3LP.showToast)(`Please enter your ${identifierType}.`, "error");
                return;
            }
            finalIdentifier = identifier;
        }
        const token = localStorage.getItem("access_token");
        const isValidTokenFormat = token && token !== "null" && token.trim() !== "" && token.split(".").length === 3;
        if (!isValidTokenFormat) {
            (0, $cP3LP.showToast)("Session expired or token is invalid. Please log in again.", "error");
            setTimeout(()=>{
                window.location.href = "/login";
            }, 2000);
            return;
        }
        // ================================================
        // STEP 1: Send OTP email
        // ================================================
        (0, $cP3LP.showGlobalPreloader)("Sending verification OTP...");
        try {
            const sendResp = await fetch("/api/user/delete-request/send-otp", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    password: password
                })
            });
            const sendData = await sendResp.json();
            if (!sendResp.ok) {
                (0, $cP3LP.showToast)(sendData.msg || sendData.error || "Could not send OTP.", "error");
                return;
            }
            $0a79f28eb2b649f5$var$state.step = $0a79f28eb2b649f5$var$DELETION_STEPS.OTP;
            $0a79f28eb2b649f5$var$state.deletionSessionToken = "";
            $0a79f28eb2b649f5$var$setDeleteStepUiState({
                step: $0a79f28eb2b649f5$var$DELETION_STEPS.OTP,
                maskedEmail: sendData.masked_email || "your registered email",
                expiresSeconds: sendData.expires_seconds || 300
            });
            (0, $cP3LP.showToast)(sendData.msg || `4-digit OTP sent to ${sendData.masked_email || "your email"}.`, "success");
            // Stash values for final submit
            formEl.dataset.finalIdentifier = finalIdentifier;
            formEl.dataset.identifierType = identifierType;
            formEl.dataset.password = password;
            formEl.dataset.reason = reason;
            document.getElementById("otp-input")?.focus();
        } catch (err) {
            (0, $cP3LP.showToast)("An error occurred sending OTP: " + err.message, "error");
        } finally{
            (0, $cP3LP.hideGlobalPreloader)();
        }
    });
    // ================================================
    // OTP "Resend code" + Step 2 submit (verify OTP → then final submit)
    // ================================================
    document.addEventListener("click", async (ev)=>{
        const target = ev.target;
        if (!target || !(target instanceof Element)) return;
        // Resend OTP
        if (target.matches('[data-deletion-otp-action="resend"]')) {
            ev.preventDefault();
            const formEl = document.getElementById("delete-user-form");
            const password = formEl ? formEl.dataset.password : "";
            const token = localStorage.getItem("access_token");
            if (!password) {
                (0, $cP3LP.showToast)("Re-enter your password first.", "error");
                $0a79f28eb2b649f5$var$goBackToStep1();
                return;
            }
            (0, $cP3LP.showGlobalPreloader)("Resending OTP...");
            try {
                const r = await fetch("/api/user/delete-request/send-otp", {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        password: password
                    })
                });
                const j = await r.json();
                if (!r.ok) {
                    (0, $cP3LP.showToast)(j.msg || j.error || "Could not resend OTP.", "error");
                    return;
                }
                (0, $cP3LP.showToast)(j.msg || "New OTP sent.", "success");
                $0a79f28eb2b649f5$var$startOtpCountdown(j.expires_seconds || 300);
            } catch (err) {
                (0, $cP3LP.showToast)("Network error: " + err.message, "error");
            } finally{
                (0, $cP3LP.hideGlobalPreloader)();
            }
            return;
        }
        // Back to Step 1
        if (target.matches('[data-deletion-otp-action="back"]')) {
            ev.preventDefault();
            $0a79f28eb2b649f5$var$goBackToStep1();
            return;
        }
        // Verify + submit final request
        if (target.matches('[data-deletion-otp-action="verify-submit"]')) {
            ev.preventDefault();
            await $0a79f28eb2b649f5$var$handleVerifyAndFinalSubmit();
        }
    });
    // OTP auto-submit on Enter key
    document.addEventListener("keydown", (ev)=>{
        if (ev.key !== "Enter") return;
        const otpEl = document.getElementById("otp-input");
        if (otpEl && document.activeElement === otpEl) {
            ev.preventDefault();
            $0a79f28eb2b649f5$var$handleVerifyAndFinalSubmit();
        }
    });
    // 4-digit auto-tabulation + digit filtering on OTP input
    const otpContainer = document.getElementById("deletion-otp-container");
    if (otpContainer) {
        otpContainer.addEventListener("input", (ev)=>{
            const input = ev.target;
            if (!(input instanceof HTMLInputElement) || !input.matches('[data-otp-digit]')) return;
            let value = input.value.replace(/\D/g, "");
            if (value.length > 1) value = value.slice(-1);
            input.value = value;
            $0a79f28eb2b649f5$var$syncOtpFromDigits();
            if (value) {
                const next = input.nextElementSibling;
                if (next instanceof HTMLInputElement && next.matches('[data-otp-digit]')) next.focus();
            }
        });
        otpContainer.addEventListener("keydown", (ev)=>{
            const input = ev.target;
            if (!(input instanceof HTMLInputElement) || !input.matches('[data-otp-digit]')) return;
            if (ev.key === "Backspace" && input.value === "") {
                const prev = input.previousElementSibling;
                if (prev instanceof HTMLInputElement) prev.focus();
            }
        });
    }
});
// ============================================================
// UI HELPERS
// ============================================================
function $0a79f28eb2b649f5$var$injectOtpStepUi() {
    const formEl = document.getElementById("delete-user-form");
    if (!formEl) return;
    if (document.getElementById("deletion-step-panel")) return;
    // 1) Step indicator above the form title area (inserted at top of form)
    const stepIndicator = document.createElement("div");
    stepIndicator.id = "deletion-step-panel";
    stepIndicator.style.cssText = [
        "display:grid",
        "grid-template-columns:1fr auto 1fr",
        "gap:8px",
        "align-items:center",
        "margin-bottom:24px",
        "font-size:0.92rem"
    ].join(";");
    stepIndicator.innerHTML = `
    <div id="step-1-pill" data-step="form" style="padding:8px 12px;border-radius:9999px;background:linear-gradient(135deg,#066fff,#00f0ff);color:#00131b;font-weight:600;display:flex;align-items:center;gap:8px;justify-content:center">
      <span style="width:22px;height:22px;border-radius:50%;background:rgba(0,19,27,.8);color:#00f0ff;display:inline-flex;align-items:center;justify-content:center;font-size:0.75rem;font-weight:700">1</span>
      Password + Confirm
    </div>
    <div style="color:#6b7684">\u{2192}</div>
    <div id="step-2-pill" data-step="otp" style="padding:8px 12px;border-radius:9999px;background:rgba(255,255,255,0.04);color:#8b949e;border:1px solid rgba(255,255,255,0.06);display:flex;align-items:center;gap:8px;justify-content:center">
      <span style="width:22px;height:22px;border-radius:50%;background:rgba(255,255,255,0.05);color:#8b949e;display:inline-flex;align-items:center;justify-content:center;font-size:0.75rem;font-weight:700">2</span>
      Email OTP Verify
    </div>
  `;
    formEl.prepend(stepIndicator);
    // 2) OTP Step Panel (hidden by default)
    const otpPanel = document.createElement("section");
    otpPanel.id = "deletion-otp-panel";
    otpPanel.style.cssText = "display:none";
    otpPanel.innerHTML = `
    <div class="form-group" style="margin-top:8px">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">
        <label for="otp-d0" style="margin:0;font-weight:600">Enter 4-digit OTP from your email</label>
        <div id="otp-countdown" style="font-size:0.85rem;color:#8b949e"></div>
      </div>
      <div id="deletion-otp-container" style="display:flex;gap:12px;justify-content:space-between;max-width:360px;margin:0 auto 16px auto">
        ${Array.from({
        length: 4
    }, (_v, i)=>`
          <input data-otp-digit="${i}" id="otp-d${i}"
            type="text" inputmode="numeric" pattern="[0-9]*" maxlength="1"
            aria-label="OTP digit ${i + 1}"
            style="width:64px;height:72px;font-size:1.8rem;font-weight:700;text-align:center;background:rgba(255,255,255,0.04);border:1px solid var(--border-color);border-radius:12px;color:var(--text-main);outline:none">
        `).join("")}
      </div>
      <input type="hidden" id="otp-input" value="">
      <div id="otp-hint" style="font-size:0.85rem;color:#8b949e;text-align:center;margin-bottom:20px">
        Sent to <span id="otp-masked-email" style="color:var(--text-main);font-weight:600">your registered email</span>. Check spam folder if missing.
      </div>
      <div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:8px">
        <button type="button" data-deletion-otp-action="back" class="btn btn-secondary" style="flex:1;min-width:160px">
          <i class="fas fa-arrow-left" style="margin-right:8px"></i>Back
        </button>
        <button type="button" data-deletion-otp-action="resend" class="btn btn-secondary" style="flex:1;min-width:160px">
          <i class="fas fa-redo" style="margin-right:8px"></i>Resend OTP
        </button>
        <button type="button" data-deletion-otp-action="verify-submit" class="btn btn-danger" style="flex:2;min-width:240px;font-weight:600">
          Verify &amp; Request Deletion
        </button>
      </div>
    </div>
  `;
    // Insert before the Submit button at the very end of the form
    const submitBtn = document.getElementById("delete-button");
    if (submitBtn && submitBtn.parentElement === formEl) formEl.insertBefore(otpPanel, submitBtn);
    else formEl.appendChild(otpPanel);
}
function $0a79f28eb2b649f5$var$setDeleteStepUiState({ step: step, maskedEmail: maskedEmail, expiresSeconds: expiresSeconds }) {
    const formFields = [
        document.getElementById("identifier-type-dropdown"),
        document.getElementById("identifier"),
        document.getElementById("phone-input-container"),
        document.getElementById("password"),
        document.getElementById("reason"),
        document.getElementById("action-confirmation"),
        document.getElementById("delete-button")
    ].filter(Boolean);
    const step1Pill = document.getElementById("step-1-pill");
    const step2Pill = document.getElementById("step-2-pill");
    const otpPanel = document.getElementById("deletion-otp-panel");
    const PILL_ACTIVE = [
        "padding:8px 12px;border-radius:9999px;background:linear-gradient(135deg,#066fff,#00f0ff);color:#00131b;font-weight:600;display:flex;align-items:center;gap:8px;justify-content:center",
        "width:22px;height:22px;border-radius:50%;background:rgba(0,19,27,.8);color:#00f0ff;display:inline-flex;align-items:center;justify-content:center;font-size:0.75rem;font-weight:700"
    ];
    const PILL_DONE = [
        "padding:8px 12px;border-radius:9999px;background:rgba(16,185,129,.15);color:#10b981;border:1px solid rgba(16,185,129,.35);display:flex;align-items:center;gap:8px;justify-content:center;font-weight:600",
        "width:22px;height:22px;border-radius:50%;background:rgba(16,185,129,.2);color:#10b981;display:inline-flex;align-items:center;justify-content:center;font-size:0.75rem;font-weight:700"
    ];
    const PILL_IDLE = [
        "padding:8px 12px;border-radius:9999px;background:rgba(255,255,255,0.04);color:#8b949e;border:1px solid rgba(255,255,255,0.06);display:flex;align-items:center;gap:8px;justify-content:center",
        "width:22px;height:22px;border-radius:50%;background:rgba(255,255,255,0.05);color:#8b949e;display:inline-flex;align-items:center;justify-content:center;font-size:0.75rem;font-weight:700"
    ];
    const applyPill = (pill, styles, numValue, badgeContent)=>{
        if (!pill) return;
        pill.setAttribute("style", styles[0]);
        const badge = pill.querySelector("span");
        if (badge) {
            badge.setAttribute("style", styles[1]);
            badge.textContent = badgeContent;
        }
    };
    if (step === $0a79f28eb2b649f5$var$DELETION_STEPS.FORM) {
        // Show Step 1, hide Step 2 OTP panel, enable form fields, rename submit button
        applyPill(step1Pill, PILL_ACTIVE, 1, "1");
        applyPill(step2Pill, PILL_IDLE, 2, "2");
        if (otpPanel) otpPanel.style.display = "none";
        formFields.forEach((el)=>{
            if (el instanceof HTMLElement) el.style.display = "";
            if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLButtonElement) el.disabled = false;
        });
        const submitBtn = document.getElementById("delete-button");
        if (submitBtn) {
            submitBtn.textContent = "Delete Account Permanently";
            submitBtn.style.display = "";
            submitBtn.disabled = !!(document.getElementById("action-confirmation") && document.getElementById("action-confirmation").value !== "delete my account");
        }
    } else if (step === $0a79f28eb2b649f5$var$DELETION_STEPS.OTP) {
        // Step 1 done, Step 2 active — collapse step 1 fields (keep visible but dim + disabled)
        applyPill(step1Pill, PILL_DONE, 1, "\u2713");
        applyPill(step2Pill, PILL_ACTIVE, 2, "2");
        if (otpPanel) otpPanel.style.display = "";
        formFields.forEach((el)=>{
            if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLButtonElement) el.disabled = true;
            else if (el instanceof HTMLElement) el.style.opacity = "0.7";
        });
        const submitBtn = document.getElementById("delete-button");
        if (submitBtn) submitBtn.style.display = "none";
        if (maskedEmail) {
            const me = document.getElementById("otp-masked-email");
            if (me) me.textContent = maskedEmail;
        }
        // Reset OTP input boxes
        document.querySelectorAll('[data-otp-digit]').forEach((d)=>{
            if (d instanceof HTMLInputElement) d.value = "";
        });
        const hiddenOtp = document.getElementById("otp-input");
        if (hiddenOtp) hiddenOtp.value = "";
        $0a79f28eb2b649f5$var$startOtpCountdown(expiresSeconds || 300);
        setTimeout(()=>{
            document.getElementById("otp-d0")?.focus();
        }, 120);
    }
}
let $0a79f28eb2b649f5$var$_otpTimer = null;
function $0a79f28eb2b649f5$var$startOtpCountdown(totalSeconds) {
    const el = document.getElementById("otp-countdown");
    if (!el) return;
    if ($0a79f28eb2b649f5$var$_otpTimer) clearInterval($0a79f28eb2b649f5$var$_otpTimer);
    let remaining = Math.max(1, Math.floor(Number(totalSeconds) || 300));
    const fmt = (s)=>{
        const m = Math.floor(s / 60);
        const ss = s % 60;
        return `${m}:${ss.toString().padStart(2, "0")}`;
    };
    el.textContent = `Expires in ${fmt(remaining)}`;
    el.style.color = "#8b949e";
    $0a79f28eb2b649f5$var$_otpTimer = setInterval(()=>{
        remaining -= 1;
        if (remaining <= 0) {
            clearInterval($0a79f28eb2b649f5$var$_otpTimer);
            el.textContent = "OTP expired \u2014 click Resend OTP";
            el.style.color = "#ef4444";
            return;
        }
        el.textContent = `Expires in ${fmt(remaining)}`;
    }, 1000);
}
function $0a79f28eb2b649f5$var$syncOtpFromDigits() {
    let out = "";
    document.querySelectorAll('[data-otp-digit]').forEach((d)=>{
        if (d instanceof HTMLInputElement) out += (d.value || "").replace(/\D/g, "");
    });
    const hidden = document.getElementById("otp-input");
    if (hidden) hidden.value = out.slice(0, 4);
}
function $0a79f28eb2b649f5$var$goBackToStep1() {
    $0a79f28eb2b649f5$var$state.step = $0a79f28eb2b649f5$var$DELETION_STEPS.FORM;
    $0a79f28eb2b649f5$var$state.deletionSessionToken = "";
    $0a79f28eb2b649f5$var$state.sessionExpiresAt = 0;
    $0a79f28eb2b649f5$var$setDeleteStepUiState({
        step: $0a79f28eb2b649f5$var$DELETION_STEPS.FORM
    });
    if ($0a79f28eb2b649f5$var$_otpTimer) {
        clearInterval($0a79f28eb2b649f5$var$_otpTimer);
        $0a79f28eb2b649f5$var$_otpTimer = null;
    }
}
async function $0a79f28eb2b649f5$var$handleVerifyAndFinalSubmit() {
    $0a79f28eb2b649f5$var$syncOtpFromDigits();
    const otp = (document.getElementById("otp-input")?.value || "").trim();
    if (otp.length !== 4 || !/^\d{4}$/.test(otp)) {
        (0, $cP3LP.showToast)("Please enter all 4 digits of the OTP.", "error");
        document.getElementById("otp-d0")?.focus();
        return;
    }
    const formEl = document.getElementById("delete-user-form");
    const token = localStorage.getItem("access_token");
    // Step A: Verify OTP → retrieve deletion_session_token
    (0, $cP3LP.showGlobalPreloader)("Verifying OTP...");
    let sessionToken;
    try {
        const vResp = await fetch("/api/user/delete-request/verify-otp", {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                otp: otp
            })
        });
        const vData = await vResp.json();
        if (!vResp.ok) {
            (0, $cP3LP.showToast)(vData.error || vData.msg || "OTP verification failed.", "error");
            if (vData.attempts_left != null && vData.attempts_left <= 1) setTimeout(()=>$0a79f28eb2b649f5$var$goBackToStep1(), 1500);
            return;
        }
        sessionToken = vData.deletion_session_token || "";
        if (!sessionToken) {
            (0, $cP3LP.showToast)("Server did not return a session token. Please retry.", "error");
            return;
        }
        $0a79f28eb2b649f5$var$state.deletionSessionToken = sessionToken;
        $0a79f28eb2b649f5$var$state.sessionExpiresAt = Date.now() + (vData.expires_seconds || 600) * 1000;
    } catch (err) {
        (0, $cP3LP.showToast)("Network error during OTP verification: " + err.message, "error");
        (0, $cP3LP.hideGlobalPreloader)();
        return;
    } finally{
        (0, $cP3LP.hideGlobalPreloader)();
    }
    // Step B: Final submit (confirmation dialog first)
    const confirmed = await $0a79f28eb2b649f5$var$showConfirmationDialog("You have verified your email via OTP. Finally \u2014 are you absolutely certain you want to submit this account deletion request? It will be sent to the Chairman for final review and is irreversible once approved.");
    if (!confirmed) {
        (0, $cP3LP.showToast)("Deletion request cancelled. You can retry any time.", "info");
        return;
    }
    (0, $cP3LP.showGlobalPreloader)("Submitting deletion request...");
    try {
        const password = formEl ? formEl.dataset.password : "";
        const reason = formEl ? formEl.dataset.reason || "" : "";
        const finalResp = await fetch("/api/user/delete-request", {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                password: password,
                reason: reason,
                deletion_session_token: sessionToken
            })
        });
        const fData = await finalResp.json();
        if (!finalResp.ok) {
            (0, $cP3LP.showToast)(fData.msg || fData.error || "Error submitting deletion request.", "error");
            if (fData.otp_required) setTimeout(()=>$0a79f28eb2b649f5$var$goBackToStep1(), 1500);
            return;
        }
        (0, $cP3LP.showToast)(fData.msg || "Your account deletion request has been sent to the Chairman.", "success");
        // Wipe OTP session
        $0a79f28eb2b649f5$var$state.deletionSessionToken = "";
        if ($0a79f28eb2b649f5$var$_otpTimer) {
            clearInterval($0a79f28eb2b649f5$var$_otpTimer);
            $0a79f28eb2b649f5$var$_otpTimer = null;
        }
        setTimeout(()=>{
            try {
                localStorage.removeItem("access_token");
                localStorage.removeItem("refresh_token");
            } catch  {
            // ignore
            }
            window.location.href = "/login";
        }, 3200);
    } catch (err) {
        (0, $cP3LP.showToast)("An error occurred: " + err.message, "error");
    } finally{
        (0, $cP3LP.hideGlobalPreloader)();
    }
}
// Custom confirmation dialog implementation
async function $0a79f28eb2b649f5$var$showConfirmationDialog(message) {
    return new Promise((resolve)=>{
        const overlay = document.createElement("div");
        overlay.style.position = "fixed";
        overlay.style.top = "0";
        overlay.style.left = "0";
        overlay.style.width = "100%";
        overlay.style.height = "100%";
        overlay.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
        overlay.style.zIndex = "9999";
        document.body.appendChild(overlay);
        const dialog = document.createElement("div");
        dialog.style.position = "fixed";
        dialog.style.top = "50%";
        dialog.style.left = "50%";
        dialog.style.transform = "translate(-50%, -50%)";
        dialog.style.backgroundColor = "#1a1a2e";
        dialog.style.padding = "30px";
        dialog.style.border = "1px solid #00f0ff";
        dialog.style.boxShadow = "0 0 20px rgba(0, 240, 255, 0.5)";
        dialog.style.borderRadius = "8px";
        dialog.style.zIndex = "10000";
        dialog.style.color = "#e0e0e0";
        dialog.style.textAlign = "center";
        dialog.style.fontFamily = "Segoe UI, Tahoma, Geneva, Verdana, sans-serif";
        dialog.style.maxWidth = "480px";
        dialog.style.width = "calc(100vw - 40px)";
        dialog.innerHTML = `
      <p style="margin-bottom: 20px; font-size: 1.05em; line-height:1.5;">${message}</p>
      <div style="display: flex; justify-content: center; gap: 15px; flex-wrap: wrap;">
        <button id="confirmYes" style="
          background-color: #e74c3c;
          color: #fff; border: none;
          padding: 10px 20px; border-radius: 5px; cursor: pointer;
          font-size: 1em; font-weight: 600;
          transition: background-color 0.3s ease, box-shadow 0.3s ease;
          min-width: 160px;
        ">Yes, Request Deletion</button>
        <button id="confirmNo" style="
          background-color: #34495e;
          color: #fff; border: none;
          padding: 10px 20px; border-radius: 5px; cursor: pointer;
          font-size: 1em;
          transition: background-color 0.3s ease, box-shadow 0.3s ease;
          min-width: 160px;
        ">Cancel</button>
      </div>
    `;
        document.body.appendChild(dialog);
        const removeDialog = ()=>{
            if (overlay.parentElement) document.body.removeChild(overlay);
            if (dialog.parentElement) document.body.removeChild(dialog);
        };
        document.getElementById("confirmYes").onclick = ()=>{
            removeDialog();
            resolve(true);
        };
        document.getElementById("confirmNo").onclick = ()=>{
            removeDialog();
            resolve(false);
        };
    });
}


//# sourceMappingURL=deleteUser.b103c955.js.map
